import { render } from "./vrecposition.vue?vue&type=template&id=cb29597a&scoped=true"
import script from "./vrecposition.vue?vue&type=script&lang=js"
export * from "./vrecposition.vue?vue&type=script&lang=js"

import "./vrecposition.vue?vue&type=style&index=0&id=cb29597a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb29597a"]])

export default __exports__